import { render, staticRenderFns } from "./motInactivo.vue?vue&type=template&id=92199dd2&scoped=true"
import script from "./motInactivo.vue?vue&type=script&lang=js"
export * from "./motInactivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92199dd2",
  null
  
)

export default component.exports